/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Reducer for faqData
 */

import type { FaqDataModule } from '@zcode/state-type'
import type { Values } from '@zcode/utility-types'
import { combineReducers } from 'redux'
import { type ExtractActions, handleActions } from 'redux-actions'

import type * as faqDataActions from '../actions'
import { RECEIVE_FAQ_DATA } from '../constants/index'

import { metaReducer } from './meta'

type ActionTypes = ExtractActions<Values<typeof faqDataActions>>

export const faqDataReducer = combineReducers<FaqDataModule, ActionTypes>({
  data: handleActions(
    {
      [RECEIVE_FAQ_DATA]: (state, { payload }) => {
        return payload
      },
    },
    null as FaqDataModule['data']
  ),
  meta: metaReducer,
})
